import { useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import i18n from "../../lib/i18n";
import MilestoneFormDialog from "./MilestoneFormDialog";
import { MdAdd } from "react-icons/md";
import Product from "../../models/Product";

import "./style.scss";

function ProgressCard(props) {
  const { percentage, children, className, onClick } = props;
  return (
    <div className={`card clickable ${className}`}
      onClick={onClick}
      style={{
        color: "#fff",
        background: `linear-gradient(90deg, var(--theme-primary-color) ${percentage}%, #bbb ${percentage}%)`
      }}
    >
      {children}
    </div>
  );
}

export default function EpicDetails(props) {
  const { milestones = [], goals = [], id } = props.data;
  const [selectedGoalId, setSelectedGoalId] = useState();
  const [selectedMilestoneId, setSelectedMilestoneId] = useState();
  const [goalModalVisible, setGoalModalVisible] = useState(false);
  const [milestoneModalVisible, setMilestoneModalVisible] = useState(false);
  const history = useHistory();

  return (
    <>
      <MilestoneFormDialog
        isOpen={milestoneModalVisible}
        selectedMilestone={milestones?.find(m => m.id === selectedMilestoneId)}
        onClose={() => setMilestoneModalVisible(false)}
        onSave={async (data) => {
          await (selectedMilestoneId ? Product.updateMilestone({ epicId: id, data }) : Product.createMilestone({ epicId: id, data }));
          setMilestoneModalVisible(false);
          history.go(0);
        }}
        data={{
          goals
        }}
      >
      </MilestoneFormDialog>
      <Link to={props.currentPath}>&lt; {i18n("common.back")}</Link>
      <div className="card m-t-md">
        <h2 className="p-md">Epic details card</h2>
      </div>
      <div className="EpicDetails flex-column flex-gap-md m-t-lg">
        <div className="flex-row flex-between flex-align-center">
          <h3>{i18n("goals.title")}</h3>
          {/* <button className="card clickable b-0 p-sm square pointer"
            onClick={() => { setSelectedGoalId(); setGoalModalVisible(true); }}
          ><MdAdd size={18} /></button> */}
        </div>
        {!goals?.length && (
          <div>{i18n("goals.empty_list.message")}</div>
        )}
        <div className="goals-container">
          {goals?.sort((a, b) => a.id - b.id).map(goal => (
            <ProgressCard
              key={goal.id}
              className="p-md pointer"
              percentage={goal.progress * 100}
              onClick={() => setSelectedGoalId(goal.id)}
            >
              <h3>
                Goal #{goal.id}
              </h3>
              <div className="m-t-sm">{goal.definition}</div>
            </ProgressCard>
          ))}
        </div>
      </div>
      <div className="flex-column flex-gap-md m-t-lg">
        <div className="flex-row flex-between flex-align-center">
          <h3>{i18n("milestones.title")}</h3>
          <button className="card clickable b-0 p-sm square pointer"
            onClick={() => { setSelectedMilestoneId(); setMilestoneModalVisible(true); }}
          ><MdAdd size={18} /></button>
        </div>
        {!milestones?.length && (
          <div>{i18n("milestones.empty_list.message")}</div>
        )}
        {milestones?.map(milestone => (
          <div className="card pointer clickable p-md" key={milestone.id}
            onClick={() => {
              setSelectedMilestoneId(milestone.id);
              setMilestoneModalVisible(true);
            }}
          >
            <h3>{milestone.name}</h3>
            <div>{milestone.description}</div>
          </div>
        ))}
      </div>
    </>
  );
}